import React from "react";

const RetailCustomerConfig = ()=>{
    const SSOURL = process.env.REACT_APP_SSOURL;
    return(
        <iframe src={`${SSOURL}/apps/pos-admin/retail-customer-configuration`} style={{ width: "100%", height: "100%",border:"none" }} title="Dynamic Content"></iframe>
    )
}

export default RetailCustomerConfig;